import React, { useEffect, useState } from "react";

// Full-circle progress ring with gradient stroke and centered content.
export default function RingProgress({
  value = 0, // 0..100
  size = 188,
  stroke = 12,
  variant = "blue",
  children,
}) {
  const [v, setV] = useState(0);
  useEffect(() => {
    const id = requestAnimationFrame(() => setV(Math.max(0, Math.min(100, value))));
    return () => cancelAnimationFrame(id);
  }, [value]);

  const r = (size - stroke) / 2;
  const c = 2 * Math.PI * r;
  const off = c - (v / 100) * c;
  const gid = `ring-${variant}`;

  return (
    <div className="ring-progress" style={{ width: size, height: size }}>
      <svg width={size} height={size}>
        <defs>
          <linearGradient id={gid} x1="0" y1="0" x2="1" y2="1">
            {variant === "gold" ? (
              <>
                <stop offset="0" stopColor="#ffd45e" />
                <stop offset="1" stopColor="#f5a623" />
              </>
            ) : (
              <>
                <stop offset="0" stopColor="#2ea8ff" />
                <stop offset="0.55" stopColor="#1e73ff" />
                <stop offset="1" stopColor="#ffc01e" />
              </>
            )}
          </linearGradient>
        </defs>
        <circle cx={size / 2} cy={size / 2} r={r} fill="none" stroke="rgba(120,160,255,0.12)" strokeWidth={stroke} />
        <circle
          className="ring-fill"
          cx={size / 2}
          cy={size / 2}
          r={r}
          fill="none"
          stroke={`url(#${gid})`}
          strokeWidth={stroke}
          strokeLinecap="round"
          strokeDasharray={c}
          strokeDashoffset={off}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div className="ring-center">{children}</div>
    </div>
  );
}
